import { useMemo } from 'react'
import { useSelector } from 'store/hooks/useSelector'

export function useDailyVisitInfo() {
  const { platform, url, videoCallToken, phoneCallToken } = useSelector((state) => {
    const wr = state.waitingRoomReducer
    return {
      platform: wr.platform,
      url: wr.roomUrl,
      videoCallToken: wr.videoCallToken,
      phoneCallToken: wr.phoneCallToken,
    }
  })

  const isDaily = platform === 'daily'

  return useMemo(() => {
    if (!isDaily || !url) return null

    const isVideoCall = !!videoCallToken
    const isPhoneCall = !isVideoCall && !!phoneCallToken

    return (
      isVideoCall ? { url, token: videoCallToken, isVideoCall, isPhoneCall }
      : isPhoneCall ? { token: phoneCallToken, url, isVideoCall, isPhoneCall }
      : null
    )
  }, [isDaily, url, videoCallToken, phoneCallToken])
}
